import { createApiCaller, createApiClient } from "./client";
import { BASE_URL_USER } from "../constants";

const client = createApiClient(BASE_URL_USER);

export default createApiCaller(client);
